<template>
  <div class="projects">

    <header-bar></header-bar>

    <section class="page-empty">
      <div class="grid-container">
        <div class="col-4 vertical-align">
          <h4>Coming soon! Projects is a new feature that will enable people to work together to create a sustainable Africa.</h4>

          <a @click="testMailchimp" class="btn btn-round green">Test Mailchimp</a>

          <a @click="addData" class="btn btn-round green">Add Data</a>

          <pre>{{testVariable}}</pre>

        </div>
      </div>
    </section>
    

  </div>
</template>

<script>
import { db } from '@/firebase'

import HeaderBar from '@/components/HeaderBar'

export default {
  data () {
    return {
      testVariable: process.env.MAILCHIMP_KEY
    }
  },
  components: {
    HeaderBar
  },
  mounted () {
    // this.mailchimp.setApiKey(process.env.MAILCHIMP_KEY)
  },
  methods: {
    testMailchimp () {
    },
    addData () {
      let list = ['Arabic', 'Bengali/Sylhetti', 'Russian', 'Japanese', 'Javanese', 'Malay/Indonesian', 'German', 'Italian', 'Korean', 'Dutch', 'Swedish', 'Finnish', 'Polish', 'Swahili', 'Afrikaans', 'Akan', 'Amharic', 'Berber', 'Chewa', 'Mauritian Creole', 'Fulani', 'Gikuyu', 'Hausa', 'Igbo', 'Kinyarwanda', 'Kirundi', 'Kongo', 'Lingala', 'Luo', 'Malagasy', 'Mossi', 'Ndebele', 'Northern Sotho', 'Oromo', 'Sesotho', 'Shilha', 'Shona', 'Somali', 'Swahili', 'Tigrinya', 'Tshiluba', 'Tswana', 'Umbundu', 'Yoruba', 'Xhosa', 'Zulu', 'Lahnda', 'Telugu', 'Marati', 'Turkish', 'Tamil', 'Vietnamise', 'Translation']
      for (let index in list) {
        db.ref('attributes/skills').push({
          category: 'Languages',
          name: list[index],
          searchterm: list[index].toLowerCase(),
          img: '/'
        })
      }
      alert('Done!')
    }
  }
}
</script>



// WEBPACK FOOTER //
// Tests.vue?7c8b9f12